import axios from '@/axios';

const state = {
  validationStatus: null,
};

const getters = {
  validationStatus: s => s.validationStatus,
};

const mutations = {
  SET_VALIDATION_STATUS(s, data) { s.validationStatus = data; },
};

const actions = {
  async fetchStatus({ commit }, { orderNo }) {
    try {
      const result = await axios.get(`/order/${orderNo}/pod-validation-status`);
      const data = result && result.data ? result.data : result;
      commit('SET_VALIDATION_STATUS', data);
      return data;
    } catch (err) {
      return null;
    }
  },

  async resubmit(_, { orderNo, destinationId }) {
    const result = await axios.post(
      `/order/${orderNo}/destination/${destinationId}/pod/resubmit`,
      {},
    );
    return result && result.data ? result.data : result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
